import { Banner } from '#/shared/components/Banner';
import { useAnalytics } from '#/shared/hooks/useAnalytics';
import { useTimesheetStore } from '#/shared/stores/timesheetStore';

export interface ForwardBannerProps {
  onForwardRequest: () => void;
}

export function ForwardBanner({ onForwardRequest }: Readonly<ForwardBannerProps>) {
  const { track } = useAnalytics();
  const timesheet = useTimesheetStore(state => state.timesheet);
  const timesheetId = timesheet?.timesheetId ?? '';
  const doctorName = timesheet?.doctorName ?? '';

  const handleActionPress = () => {
    track('Online approval web - Forward request', {
      Timesheet_ID: timesheetId,
      Origination_Source: 'web',
    });
    onForwardRequest();
  };

  return (
    <Banner
      title="Not the right approver?"
      supportingText={`Enter the new approver’s details and we’ll notify ${doctorName}. This link and its contents are confidential, please do not use or share this link.`}
      action={{
        label: 'Forward approval request',
        onPress: handleActionPress,
      }}
    />
  );
}
